(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));

  qsa('[data-elarte-menu-open]').forEach(btn => {
    btn.addEventListener('click', () => {
      const drawer = qs('#elarte-mobile-drawer');
      if (drawer) drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    });
  });
  qsa('[data-elarte-menu-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      const drawer = qs('#elarte-mobile-drawer');
      if (drawer) drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    });
  });

  qsa('[data-elarte-tabs]').forEach(group => {
    const buttons = qsa('[data-tab-button]', group);
    const panels = qsa('[data-tab-panel]', group);
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-tab-button');
        buttons.forEach(b => b.setAttribute('aria-selected', b === button ? 'true' : 'false'));
        panels.forEach(panel => panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === id));
      });
    });
  });

  qsa('[data-elarte-quiz]').forEach(quiz => {
    let current = 0;
    const screens = qsa('[data-quiz-screen]', quiz);
    const result = qs('[data-quiz-result]', quiz);
    const resultTitle = qs('[data-result-title]', quiz);
    const resultMeta = qs('[data-result-meta]', quiz);
    const resultLink = qs('[data-result-link]', quiz);
    const resetBtn = qs('[data-quiz-reset]', quiz);
    const answers = {};
    const routes = JSON.parse(quiz.getAttribute('data-routes') || '{}');

    const show = (index) => {
      screens.forEach((screen, i) => screen.classList.toggle('is-active', i === index));
      if (result) result.classList.remove('is-active');
      current = index;
    };
    const finish = () => {
      const key = answers.path || answers.q1 || 'vision';
      const data = routes[key] || routes.vision || {};
      screens.forEach(screen => screen.classList.remove('is-active'));
      if (resultTitle) resultTitle.textContent = data.title || 'Find Your Vision';
      if (resultMeta) resultMeta.textContent = data.meta || 'Mriya Gallery · 20 guests';
      if (resultLink) resultLink.href = data.url || '/pages/gatherings';
      if (result) result.classList.add('is-active');
    };
    qsa('[data-quiz-answer]', quiz).forEach(btn => {
      btn.addEventListener('click', () => {
        const screen = btn.closest('[data-quiz-screen]');
        const screenIndex = screens.indexOf(screen);
        qsa('[data-quiz-answer]', screen).forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const key = btn.getAttribute('data-question-key') || `q${screenIndex + 1}`;
        answers[key] = btn.getAttribute('data-quiz-answer');
        if (screenIndex === 0) answers.path = btn.getAttribute('data-quiz-answer');
        setTimeout(() => {
          if (screenIndex < screens.length - 1) show(screenIndex + 1);
          else finish();
        }, 180);
      });
    });
    if (resetBtn) resetBtn.addEventListener('click', () => show(0));
    show(0);
  });

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    qsa('.elarte-reveal').forEach(el => io.observe(el));
  } else {
    qsa('.elarte-reveal').forEach(el => el.classList.add('is-visible'));
  }
})();
